import { transformISODate } from '../utils';

export const hasValidRecordDates = (
  availableDates: string[],
  recordFrom: string | null | undefined,
  recordTo: string | null | undefined
): boolean => {
  const hasAvailableDates = availableDates.length > 0;
  const hasDates = typeof recordFrom !== 'undefined' || typeof recordTo !== 'undefined';
  const availableDatesList = availableDates.map((date) => transformISODate(date));
  const hasValidDates =
    hasDates && availableDatesList.includes(recordFrom as string) && availableDatesList.includes(recordTo as string);
  const hasValidDatesRange = new Date(recordFrom as string) <= new Date(recordTo as string);

  return hasAvailableDates && hasValidDatesRange && hasDates && hasValidDates;
};

export const hasValidPeriod = (period: string | null | undefined, availableDates: string[]): boolean => {
  const periodAvailable = ['ALL', 'LAST_THREE_MONTHS'];
  const hasPeriod = typeof period !== 'undefined';
  const hasValidPeriod = hasPeriod && periodAvailable.includes(period as string) && availableDates.length > 0;
  const hasValidLastThreeMonths = hasPeriod && periodAvailable.includes(period as string) && availableDates.length > 2;
  return period === 'LAST_THREE_MONTHS' ? hasValidLastThreeMonths : hasValidPeriod;
};
